export const ENROLL_SMS = 'ENROLL_SMS';
export const REPORT_ISSUE = 'REPORT_ISSUE';
export const SCHEDULE_CALLBACK = 'SCHEDULE_CALLBACK';
